"use client"

import { Typography } from "antd";
import { ParagraphProps } from "antd/es/typography/Paragraph";
import { FC } from "react";

const Paragraph: FC<ParagraphProps> = (props) => {
  return (
    <Typography.Paragraph {...props} />
  )
}

Paragraph.displayName = 'Paragraph'

export default Paragraph